import { apiGet, apiPost, apiPatch, apiDelete } from '../lib/api'

export const RESULTS_LOAD_SUCCESS = 'RESULTS_LOAD_SUCCESS'
export const RESULT_CREATE_SUCCESS = 'RESULT_CREATE_SUCCESS'
export const RESULT_LOAD_SUCCESS = 'RESULT_LOAD_SUCCESS'
export const RESULT_UPDATE_SUCCESS = 'RESULT_UPDATE_SUCCESS'
export const RESULT_DELETE_SUCCESS = 'RESULT_DELETE_SUCCESS'
export const RESULT_SET_DRIVE_END_TIME = 'RESULT_SET_DRIVE_END_TIME'
export const RESULT_CLEAR_DRIVE_END_TIME = 'RESULT_CLEAR_DRIVE_END_TIME'
export const MISTAKE_ADD = 'MISTAKE_ADD'
export const MISTAKE_COUNT_INCREMENT = 'MISTAKE_COUNT_INCREMENT'
export const MISTAKE_COUNT_DECREMENT = 'MISTAKE_COUNT_DECREMENT'
export const DELETE_MISTAKE = 'DELETE_MISTAKE'
export const CLEAR_MISTAKES = 'CLEAR_MISTAKES'
export const RESULT_UPDATE_CURRENT_LOCALLY = 'RESULT_UPDATE_CURRENT_LOCALLY'
export const RESULT_ADD_IMAGE_NOTE = 'RESULT_ADD_IMAGE_NOTE'
export const CLEAR_IMAGE_NOTES = 'CLEAR_IMAGE_NOTES'
export const SET_CURRENT_MISTAKE_TYPE = 'SET_CURRENT_MISTAKE_TYPE'
export const CLEAR_CURRENT_MISTAKE_TYPE = 'CLEAR_CURRENT_MISTAKE_TYPE'
export const RESULT_EDIT_IMAGE_NOTE = 'RESULT_EDIT_IMAGE_NOTE'
export const RESULT_REMOVE_IMAGE_NOTE = 'RESULT_REMOVE_IMAGE_NOTE'
export const SET_RESULT_SUMMARY_NOTE = 'SET_RESULT_SUMMARY_NOTE'
export const SET_MISTAKE_PREFIX = 'SET_MISTAKE_PREFIX'

export const CLEAR_RESULTS = 'CLEAR_RESULTS'
export const CLEAR_RESULT = 'CLEAR_RESULT'
export const CLEAR_END_OF_DRIVE_TIME = 'CLEAR_END_OF_DRIVE_TIME'
export const CLEAR_RESULT_SUMMARY_NOTES = 'CLEAR_RESULT_SUMMARY_NOTES'

export const loadResults = (query) => ({ getState, fetch }) => ({
  type: 'RESULTS_LOAD',
  payload: apiGet({
    fetch,
    endpoint: 'results',
    getState,
    query,
  }),
})

export const loadResult = (id) => ({ getState, fetch }) => ({
  type: 'RESULT_LOAD',
  payload: apiGet({
    fetch,
    endpoint: `results/${id}`,
    getState,
  }),
})

export const createResult = (body) => ({ getState, fetch }) => ({
  type: 'RESULT_CREATE',
  payload: apiPost({
    fetch,
    endpoint: 'results',
    getState,
    body,
  }),
})

export const updateResult = (body) => ({ getState, fetch }) => ({
  type: 'RESULT_UPDATE',
  payload: apiPatch({
    fetch,
    endpoint: `results/${body._id}`,
    getState,
    body,
  }),
})

export const updateCurrentResultLocally = (body) => ({
  type: RESULT_UPDATE_CURRENT_LOCALLY,
  payload: { body },
})

export const deleteResult = (id) => ({ getState, fetch }) => ({
  type: 'RESULT_DELETE',
  payload: apiDelete({
    fetch,
    endpoint: `results/${id}`,
    getState,
  }),
})

export const setDriveEndTime = (minutes) => ({
  type: RESULT_SET_DRIVE_END_TIME,
  payload: { minutes },
})

export const clearDriveEndTime = () => ({
  type: RESULT_CLEAR_DRIVE_END_TIME,
})

export const clearResults = () => ({
  type: 'CLEAR_RESULTS',
  payload: {},
})

export const clearResult = () => ({
  type: 'CLEAR_RESULT',
  payload: {},
})

export const addImageNote = (image, type) => ({
  type: RESULT_ADD_IMAGE_NOTE,
  payload: { image, type },
})

export const editImageNote = (image, index) => ({
  type: RESULT_EDIT_IMAGE_NOTE,
  payload: { image, index },
})

export const getResultsCSV = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_RESULTS_CSV',
  payload: apiGet({
    fetch,
    endpoint: 'results/csv',
    getState,
    query,
  }),
})

export const addMistake = (mistake) => ({
  type: MISTAKE_ADD,
  payload: { mistake },
})

export const incrementMistakeCount = (index) => ({
  type: MISTAKE_COUNT_INCREMENT,
  payload: { index },
})

export const decrementMistakeCount = (index) => ({
  type: MISTAKE_COUNT_DECREMENT,
  payload: { index },
})

export const deleteMistake = (index) => ({
  type: DELETE_MISTAKE,
  payload: { index },
})

export const clearMistakes = () => ({
  type: CLEAR_MISTAKES,
})

export const setMistakePrefix = (index, prefix) => ({
  type: SET_MISTAKE_PREFIX,
  payload: { index, prefix },
})

export const setCurrentMistakeType = (type) => ({
  type: SET_CURRENT_MISTAKE_TYPE,
  payload: { type },
})

export const clearCurrentMistakeType = () => ({
  type: CLEAR_CURRENT_MISTAKE_TYPE,
})

export const clearImageNotes = () => ({
  type: CLEAR_IMAGE_NOTES,
})

export const clearEndOfDriveTime = () => ({
  type: CLEAR_END_OF_DRIVE_TIME,
})

export const clearResultSummaryNotes = () => ({
  type: CLEAR_RESULT_SUMMARY_NOTES,
})

export const getCertificatesZip = (query) => ({ getState, fetch }) => ({
  type: 'DOWNLOAD_CERTIFICATES_ZIP',
  payload: apiGet({
    fetch,
    endpoint: 'results/zip',
    getState,
    query,
  }),
})

export const setResultSummaryNote = (image, field) => ({
  type: SET_RESULT_SUMMARY_NOTE,
  payload: {
    image,
    field,
  },
})

export const removeImageNote = (index) => ({
  type: RESULT_REMOVE_IMAGE_NOTE,
  payload: { index },
})



// WEBPACK FOOTER //
// ./src/common/results/actions.js